import React, { useEffect, useState } from 'react';
import { useDeviceSize } from 'src/hooks';
import type { ComputedDevice } from 'src/lib/utils';

const ReversableDOM: React.FC<{
  first: React.ReactNode;
  second: React.ReactNode;
  reversed: boolean;
}> = ({ first, second, reversed }) => {
  return (
    <>
      {reversed ? (
        <>
          {second}
          {first}
        </>
      ) : (
        <>
          {first}
          {second}
        </>
      )}
    </>
  );
};

const ReversableBreakpoint: React.FC<{
  first: React.ReactNode;
  second: React.ReactNode;
  breakpoint: (v: ComputedDevice) => boolean;
}> = ({ first, second, breakpoint }) => {
  const deviceSize = useDeviceSize();
  const [reversed, setReversed] = useState<boolean>();

  useEffect(() => {
    setReversed(breakpoint(deviceSize));
  }, [breakpoint, deviceSize]);

  return <ReversableDOM first={first} second={second} reversed={reversed} />;
};

/** Reverses two nodes in the DOM for A11Y when `reversed` or once a given breakpoint is reached */
const Reversable: React.FC<{
  first: React.ReactNode;
  second: React.ReactNode;
  breakpoint?: (v: ComputedDevice) => boolean;
  reversed?: boolean;
}> = ({ first, second, breakpoint, reversed = false }) => {
  return reversed || !breakpoint ? (
    <ReversableDOM first={first} second={second} reversed={reversed} />
  ) : (
    <ReversableBreakpoint
      first={first}
      second={second}
      breakpoint={breakpoint}
    />
  );
};

export default Reversable;
